/* ============================================================================
   IMAGES PAR LANGUE — remplace le module « Localisation d'images » de Reversia.

   Principe : Shopify ne permet pas nativement une image de galerie différente
   par langue (seul l'alt est traduisible). Ce script récupère le mapping
   « image FR -> image localisée » servi par NOTRE app (claude-localize, endpoint
   public en cache 2 min) et échange les images côté client.

   - Chargé UNIQUEMENT hors du français (condition Liquid dans theme.liquid) ;
   - matching par URL (nom de fichier, insensible aux suffixes de taille _800x
     et aux paramètres ?v=/&width=) + par data-media-id (galeries Dawn) ;
   - un MutationObserver rattrape les images ajoutées ou re-sourcées après coup
     (carrousels, changement de variante, sections chargées dynamiquement) ;
   - échec réseau = site inchangé (les images FR restent affichées).

   Config lue sur la balise <script> : data-endpoint (URL de l'API) et
   data-locale (langue de la page, posée par Liquid).
   ========================================================================== */
(function () {
  "use strict";

  var tag = document.currentScript;
  var endpoint = tag && tag.getAttribute("data-endpoint");
  var locale = tag && tag.getAttribute("data-locale");
  if (!endpoint || !locale) return;

  /* Clé de matching d'une URL d'image : le NOM DE FICHIER seul, sans query ni
     suffixe de taille Shopify (_360x, _800x600, @2x…), en minuscules.
     Le même fichier est servi sous plusieurs chemins selon le contexte —
     « cdn.shopify.com/s/files/1/…/files/X.jpg » (nos mappings) vs
     « www.shapeheart.it/cdn/shop/files/X.jpg » (rendu de la page) — seul le
     nom de fichier est stable (unique par store dans la CDN Shopify).
     Ex. « //shop/cdn/shop/files/MOTO_-_2nd_800x.jpg?v=17 » -> « moto_-_2nd.jpg ». */
  function urlKey(url) {
    if (!url) return "";
    var path = String(url).split("?")[0];
    var file = path.substring(path.lastIndexOf("/") + 1);
    try { file = decodeURIComponent(file); } catch (e) { /* nom déjà décodé */ }
    return file
      .replace(/_(?:\d+x\d*|x\d+)(?=\.[a-z0-9]+$)/i, "")
      .replace(/@\dx(?=\.[a-z0-9]+$)/i, "")
      .toLowerCase();
  }

  var byUrl = {};   // urlKey(image FR)      -> {url, alt}
  var byMedia = {}; // id numérique du média -> {url, alt}

  /* Remplace src/srcset/alt d'un <img> par l'image localisée.
     Le srcset est reconstruit avec ?width= (le CDN Shopify redimensionne à la
     volée) pour garder le comportement responsive du thème. */
  function swapImg(img, override) {
    if (!img || !override || !override.url) return;
    if (img.getAttribute("src") === override.url) return; // déjà échangée
    var widths = [];
    (img.getAttribute("srcset") || "").split(",").forEach(function (entry) {
      var m = entry.trim().match(/\s(\d+)w$/);
      if (m) widths.push(m[1]);
    });
    var sep = override.url.indexOf("?") === -1 ? "?" : "&";
    if (widths.length) {
      img.setAttribute("srcset", widths.map(function (w) {
        return override.url + sep + "width=" + w + " " + w + "w";
      }).join(", "));
    } else if (img.hasAttribute("srcset")) {
      img.removeAttribute("srcset"); // pas de largeurs exploitables -> src seul
    }
    img.setAttribute("src", override.url);
    if (override.alt) img.setAttribute("alt", override.alt);
  }

  /* Passe sur un sous-arbre : matche chaque <img> par URL, puis les galeries
     Dawn par data-media-id (l'attribut finit par l'id numérique du média). */
  function localize(root) {
    var imgs = root.querySelectorAll ? root.querySelectorAll("img[src]") : [];
    for (var i = 0; i < imgs.length; i++) {
      var over = byUrl[urlKey(imgs[i].getAttribute("src"))];
      if (over) swapImg(imgs[i], over);
    }
    var holders = root.querySelectorAll ? root.querySelectorAll("[data-media-id]") : [];
    for (var j = 0; j < holders.length; j++) {
      var mid = (holders[j].getAttribute("data-media-id") || "").match(/(\d+)$/);
      var overM = mid && byMedia[mid[1]];
      if (!overM) continue;
      var inner = holders[j].querySelectorAll("img");
      for (var k = 0; k < inner.length; k++) swapImg(inner[k], overM);
    }
  }

  function start(overrides) {
    if (!overrides || !overrides.length) return;
    overrides.forEach(function (o) {
      if (!o || !o.overrideImageUrl) return;
      var entry = { url: o.overrideImageUrl, alt: o.overrideAlt || "" };
      var key = urlKey(o.originalImageUrl);
      if (key) byUrl[key] = entry;
      var mid = String(o.shopifyMediaGid || "").match(/MediaImage\/(\d+)/);
      if (mid) byMedia[mid[1]] = entry;
    });

    localize(document);

    /* Rattrapage : nœuds ajoutés (carrousels clonés, sections AJAX) et images
       re-sourcées par le thème (changement de variante). swapImg est idempotent
       (il ignore une image déjà à jour), donc pas de boucle avec l'observer. */
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === "attributes") {
          var over = byUrl[urlKey(m.target.getAttribute("src"))];
          if (over) swapImg(m.target, over);
        } else {
          for (var j = 0; j < m.addedNodes.length; j++) {
            if (m.addedNodes[j].nodeType === 1) localize(m.addedNodes[j]);
          }
        }
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["src"],
    });
  }

  /* Cache sessionStorage 2 min (aligné sur le cache HTTP de l'endpoint) :
     évite une requête à chaque page ; une image posée dans le dashboard est
     visible sur le site en ~2 min maximum, comme l'annonce le toast. */
  var CACHE_KEY = "lz-img-overrides:" + locale;
  try {
    var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || "null");
    if (cached && Date.now() - cached.at < 120000) {
      start(cached.overrides);
      return;
    }
  } catch (e) { /* cache illisible -> on refait la requête */ }

  fetch(endpoint + "?locale=" + encodeURIComponent(locale), { credentials: "omit" })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      var overrides = (data && data.overrides) || [];
      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), overrides: overrides }));
      } catch (e) { /* stockage plein/privé : tant pis pour le cache */ }
      start(overrides);
    })
    .catch(function () { /* endpoint injoignable -> images FR, site intact */ });
})();
